(function () {
  'use strict';

  /* @ngdoc object
   * @name messageAdmin
   * @description
   *
   */
  angular
    .module('messageAdmin', [
      'ui.router'
    ]);
}());
